import React from "react";
import banner from '../assets/imgs/novo-nossocredito.jpeg';

const AcxHeader = () => {
  return (
    <img id="banner" width={'100%'} src={banner} alt='Banner Nova Santa Rita' />
  )
}

export default AcxHeader;
